<template>
  <section>
    <div class="container" id="contact-us">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <h2>Contact Us</h2>
          <p>
            You need a little rest, let us do the work for you!
          </p>
          <div class="card col-md-8">
            <div class="container">
              <ValidationObserver ref="form">
                <ValidationProvider name="Full Name" rules="required" v-slot="{ errors }">
                  <base-input class="ph-padding-left" alternative placeholder="Full Name" addon-left-icon="fa fa-user"
                    v-model="form.fullName" :error="errors[0]" />
                </ValidationProvider>

                <ValidationProvider name="Company Name" rules="required" v-slot="{ errors }">
                  <base-input class="mt-4 ph-padding-left" alternative placeholder="Company"
                    addon-left-icon="fa fa-building" v-model="form.companyName" :error="errors[0]" />
                </ValidationProvider>

                <ValidationProvider name="Email Address" rules="required" v-slot="{ errors }">
                  <base-input class="ph-padding-left" alternative placeholder="Email Address"
                    addon-left-icon="fa fa-envelope" v-model="form.email" :error="errors[0]" />
                </ValidationProvider>

                <ValidationProvider name="Phone Number" rules="required" v-slot="{ errors }">
                  <base-input class="ph-padding-left" alternative placeholder="Phone Number" addon-left-icon="fa fa-phone"
                    v-model="form.phoneNumber" :error="errors[0]" />
                </ValidationProvider>

                <base-input class="mb-4">
                  <ValidationProvider name="Message" rules="required" v-slot="{ errors }">
                    <textarea class="form-control form-control-alternative" name="name" rows="4" cols="80"
                      placeholder="Type a message..." v-model="form.message" maxlength="1000" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </base-input>
              </ValidationObserver>
              <base-button class="button" round block size="lg" @click="onSubmit">SUBMIT</base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// API & DAO
import inquiryDAO from '@/database/inquiries';

// Others
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "contact-us",
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      form: {
        companyName: "",
        fullName: "",
        email: "",
        phoneNumber: "",
        message: "",
      },
    };
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        this.$toast.warning("Please address the field/s with invalid input.");
        return;
      }

      // show loading indicator
      this.isLoading = true;

      try {
        let inquiry = { ...this.form };
        inquiry.inquiryId = this.generateCustomID();
        inquiry.dateSent = new Date().getTime();
        inquiry.recipient = "support@tawitech.ph";
        inquiry.type = "CUSTOMER_INQUIRY";
        inquiry.title = "New Customer Inquiry";
        inquiry.isViewed = false;

        await inquiryDAO.createInquiry(inquiry);

        this.$toast.success(
          "Please wait for a customer representative to contact you using the contact details you've inputted.",
          "Your message has been sent!"
        );

        this.$refs.form.reset();
        this.resetForm();
      } catch (_error) {
        this.$toast.error("Something went wrong, please try again.", "Oops!");
      }

      // hide loading indicator
      this.isLoading = false;
    },
    generateCustomID() {
      return "TAWITECH" + Date.now();
    },
    resetForm() {
      this.form = {
        companyName: "",
        fullName: "",
        email: "",
        phoneNumber: "",
        message: "",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
section {
  padding: 50px;
  background-color: #f4f3f3;
  background-image: url("/img/backgrounds/contact-us-background.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

h2 {
  color: white;
  text-align: center;
  font-weight: 700;
}

p {
  font-size: 20px;
  color: white;
  text-align: center;
  font-weight: 400;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: #343434;
  border: solid black 2px;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.image {
  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  margin-bottom: 20px;
}

h3 {
  font-size: 20px;
  text-align: center;
}

.button {
  color: white;
  background-color: #343434;
  border: solid black 2px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 1vw;
  width: fit-content;
  float: right;
  position: sticky;
  margin-top: 35px;
}

.button:hover {
  background-color: white;
  border-color: black;
}

.ph-padding-left ::placeholder {
  padding-left: 5px;
}

@media only screen and (max-width: 768px) and (min-width: 375px) {
  section {
    padding: 30px;
  }

  h2 {
    font-size: 30px;
  }

  p {
    font-size: 14px;
  }

  h3 {
    font-size: 14px;
  }

  .button {
    font-size: small;
    margin-bottom: 50px;
  }
}
</style>
